import { render, staticRenderFns } from "./AppointmentsSettingsList.vue?vue&type=template&id=7b74ff62&scoped=true&"
import script from "./AppointmentsSettingsList.vue?vue&type=script&lang=ts&"
export * from "./AppointmentsSettingsList.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentsSettingsList.vue?vue&type=style&index=0&id=7b74ff62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b74ff62",
  null
  
)

export default component.exports